'use client';

import {useCallback, useState} from 'react';

import {
  useAuthorizedProfile,
  useAuthProgressState,
} from '@web-catalog/store/auth';

import {SpriteIcon} from '@web-catalog/ui-kit/SpriteIcon';

import {logAuthorizationHeaderClick} from '@web-catalog/utils/analytics/authAnalytics';

import styles from './AuthHeaderComponent.module.scss';
import {Avatar} from './parts/Avatar';

type Props = {
  size: number;
};

export const AuthHeaderComponent = ({size}: Props) => {
  const userInfo = useAuthorizedProfile();
  const authProgressState = useAuthProgressState();

  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const handleShowTooltip = useCallback(() => {
    logAuthorizationHeaderClick();
    setIsTooltipVisible(true);
  }, []);

  const handleHideTooltip = useCallback(() => {
    setIsTooltipVisible(false);
  }, []);

  return (
    <div
      className={styles.container}
      data-testid="auth-header-comp"
      onMouseOver={handleShowTooltip}
      onMouseOut={handleHideTooltip}
    >
      <Avatar size={size} />
      {isTooltipVisible && authProgressState !== 'notify_user' && (
        <div className={styles.tooltip}>
          <div className={styles.name}>
            {userInfo?.first_name ?? userInfo?.id}
          </div>
          <div className={styles.id}>
            Вы вошли с помощью <span className="visually-hidden">VK ID</span>
            <SpriteIcon svg="vk_id" color="black" />
          </div>
        </div>
      )}
    </div>
  );
};
